import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, EventsContext, LanguageContext, NotificationContext } from '../context'
import useEventActions from '../hooks/useEventActions'
import { AddressInput, DateInput } from './UI'
import { AUTH_PROMPT_TYPE } from '../utils/constants'
import PhoneCustomInput from './UI/PhoneInput'

function VehicleModal({ showModal, onClose, event, vehicle, vehicleIndex }) {

  const { userData, isUserAuthenticated, promptAuth } = useContext(AuthContext)
  const { isEventOrganiser } = useEventActions({ event })

  const { addVehicleToEvent, removeVehicleFromEvent, updateEventVehicle } = useContext(EventsContext)
  const { prompt, toast } = useContext(NotificationContext)
  const { t } = useContext(LanguageContext)


  // driver_firstname: string, // TBD: Should we store this?
  // driver_lastname: string, // TBD: Should we store this?
  // email: string,
  // phone: string,
  // available_seats: number,
  // passengers: Person[],
  // trip1: Address,
  // trip2: Address,
  // trip1_date: string, // ISO 8601 date
  // trip2_date: string, // ISO 8601 date

  // address:

  // street: string,
  // number: string,
  // city: string,
  // zip: string,
  // country: string,

  const [vehicleData, setVehicleData] = useState({
    driver_firstname: '',
    driver_lastname: '',
    phone: '',
    email: '',
    trip1: {
      available: false,
      street: '',
      number: '',
      city: '',
      zip: '',
      country: '',
      address_flat: '',
      available_seats: 1,
      date: '',
      formatted: ''
    },
    trip2: {
      available: false,
      street: '',
      number: '',
      city: '',
      zip: '',
      country: '',
      address_flat: '',
      available_seats: 1,
      date: '',
      formatted: ''
    },
    notes: ''
  })
  const [formSubmitted, setFormSubmitted] = useState(false)

  useEffect(() => {
    if (!vehicle) return
    setVehicleData({ ...vehicle })
  }, [vehicle])

  useEffect(() => {
    if (!event) return
    setVehicleData((data) => {
      if (!data.trip1) {
        data.trip1 = {}
      }
      if (!data.trip1.date) {
        data.trip1.date = event.start
      }
      if (!data.trip1.street && userData?.address) {
        data.trip1.street = userData.address.street || ''
        data.trip1.number = userData.address.number || ''
        data.trip1.city = userData.address.city || ''
        data.trip1.zip = userData.address.zip || ''
        data.trip1.country = userData.address.country || ''
        data.trip1.address_flat = userData.address.formatted || ''
        data.trip1.formatted = userData.address.formatted || ''
      }
      if (!data.trip2) {
        data.trip2 = {}
      }
      if (!data.trip2.date) {
        data.trip2.date = event.end
      }
      // TODO validate if address should be pre-filled
      if (!data.trip2.street && userData?.address) {
        data.trip2.street = userData.address.street || ''
        data.trip2.number = userData.address.number || ''
        data.trip2.city = userData.address.city || ''
        data.trip2.zip = userData.address.zip || ''
        data.trip2.country = userData.address.country || ''
        data.trip2.address_flat = userData.address.formatted || ''
        data.trip2.formatted = userData.address.formatted || ''
      }
      return data
    })
  }, [event, userData])

  const [loading, setLoading] = useState(false)


  useEffect(() => {
    if (!userData) return
    setVehicleData(data => {
      const updatedData = { ...data }
      if (!data.driver_firstname && userData.firstname) {
        updatedData.driver_firstname = userData.firstname
      }
      if (!data.driver_lastname && userData.lastname) {
        updatedData.driver_lastname = userData.lastname
      }
      if (!data.email && userData.email) {
        updatedData.email = userData.email
      }
      if (!data.phone && userData.phone) {
        updatedData.phone = userData.phone
      }
      return updatedData
    })
  }, [userData])

  useEffect(() => {
    // location & number of seat for return trip : by default display the same as for the 'go' trip (if user check 'return' after having complete 'go') 
    if (vehicleData.trip1.available) {
      if (!vehicleData.trip2.formatted) {
        setVehicleData({
          ...vehicleData,
          trip2: {
            ...vehicleData.trip2,
            street: vehicleData.trip1.street,
            number: vehicleData.trip1.number,
            city: vehicleData.trip1.city,
            zip: vehicleData.trip1.zip,
            country: vehicleData.trip1.country,
            address_flat: vehicleData.trip1.address_flat,
            available_seats: vehicleData.trip1.available_seats,
            formatted: vehicleData.trip1.formatted,
          }
        });
      }
    }

  }, [vehicleData.trip2.available])

  const handleChange = (key) => (e) => {
    const keyComponents = key.split('.')
    if (keyComponents.length > 1) {
      setVehicleData(data => ({
        ...data,
        [keyComponents[0]]: {
          ...vehicleData[keyComponents[0]],
          [keyComponents[1]]: e.target.value
        }
      }))
      return
    }
    setVehicleData(data => {
      if (typeof data[key] === 'object') {
        return { ...data, [key]: { ...data[key], ...e.target.value } }
      }
      return { ...data, [key]: e.target.value }
    })
  }

  const handlePhoneChange = (e) => {
    setVehicleData({ ...vehicleData, phone: e })
  }

  const handleCancel = () => {
    onClose()
  }

  const handleSubmitVehicle = async () => {
    setLoading(true)
    if (vehicleIndex === undefined || vehicleIndex === -1) {
      await addVehicleToEvent(event.id, vehicleData)
    } else {
      await updateEventVehicle(event.id, vehicleIndex, vehicleData)
    }
    setLoading(false)
    onClose()
    toast({ message: t('generic.changes_saved'), variant: 'success' })
  }

  const handleSubmit = async () => {
    setFormSubmitted(true)
    if (!vehicleData.driver_firstname || !vehicleData.driver_lastname || !vehicleData.phone || !vehicleData.email) {
      toast({ message: t('generic.complete_all_fields'), variant: 'error' })
      return
    }
    if (!vehicleData.trip1.available && !vehicleData.trip2.available) {
      toast({ message: t('vehicle.select_journey'), variant: 'error' })
      return
    }
    if (vehicleData.trip1.available) {
      if (!vehicleData.trip1 || !vehicleData.trip1.date || !vehicleData.trip1.available_seats || !vehicleData.trip1.street) {
        toast({ message: t('generic.complete_all_fields'), variant: 'error' })
        return
      }
    }
    if (vehicleData.trip2.available) {
      if (!vehicleData.trip2 || !vehicleData.trip2.date || !vehicleData.trip2.available_seats || !vehicleData.trip2.street) {
        toast({ message: t('generic.complete_all_fields'), variant: 'error' })
        return
      }
    }

    if (!isUserAuthenticated) {
      promptAuth(AUTH_PROMPT_TYPE.SIGNUP, { email: vehicleData.email }, handleSubmitVehicle)
      return
    }
    handleSubmitVehicle()
  }

  const handleDelete = async () => {
    const response = await prompt({ message: t('vehicle.delete_confirm'), buttons: [{ label: t('generic.cancel'), value: 'cancel', variant: 'default' }, { label: t('generic.confirm'), value: 'confirm', variant: 'primary' }] })
    if (response !== 'confirm') return
    setLoading(true)
    await removeVehicleFromEvent(event.id, vehicleIndex)
    setLoading(false)
    onClose()
  }

  const displayDate = (date) => {
    if (date) {
      return new Date(date)
    }
    return null
  }


  return (
    <div className={`w-full ${showModal ? '' : 'hidden'}`}>
      <div
        className="justify-center items-center z-50 rounded-lg modal-container ">
        <div className="flex items-start justify-between pt-16 pb-9 px-5  ">
          <h3 className="modal-title">
            {isEventOrganiser() ? t('vehicle.organiser_add_title') : t('vehicle.add_title')}
          </h3>
          <button
            className="p-1 bg-transparent text-black text-3xl absolute top-2 right-4"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        {/*body*/}
        <div className="modal-box">

          <div>
            <div className='mb-4'>
              <label className='block mb-2 required'>
                {t('generic.firstname')}*
              </label>
              <input type='text' className={formSubmitted && !vehicleData.driver_firstname ? '!border-red-500' : ''} value={vehicleData.driver_firstname} onChange={handleChange('driver_firstname')}
                name='firstName' autoComplete='on' />
            </div>
            <div className='mb-4'>
              <label className='block mb-2 required'>
                {t('generic.lastname')}*
              </label>
              <input type='text' className={formSubmitted && !vehicleData.driver_lastname ? '!border-red-500' : ''} value={vehicleData.driver_lastname} onChange={handleChange('driver_lastname')}
                name='lastName' autoComplete='on' />
            </div>
            <div className='mb-4'>
              <label className='block mb-2 required'>
                {t('generic.phone')}*
              </label>
              <div className='flex w-full'>
                <PhoneCustomInput
                  value={vehicleData.phone}
                  onChange={handlePhoneChange}
                  inputClass={'!border-red-500'}
                  inputProps={{
                    className: (formSubmitted && !vehicleData.phone) ? '!border-red-500' : ''
                  }}
                />
              </div>
            </div>
            <div className='mb-4'>
              <label className='block mb-2 required'>
                {t('generic.email')}*
              </label>
              <input type='email' className={formSubmitted && !vehicleData.email ? '!border-red-500' : ''} value={vehicleData.email} onChange={handleChange('email')} name='email' autoComplete='on' />
            </div>
            <div className='journey-block mb-4'>
              <div className='block mb-2 custom-checkbox'>
                <input type='checkbox'
                  checked={vehicleData.trip1.available}
                  onChange={e => { handleChange('trip1.available')({ target: { value: e.target.checked } }) }}
                  id='checkbox1' />
                <label className='block leading-7' htmlFor='checkbox1'>
                  {t('vehicle.trip1_label')}
                </label>
              </div>
              <div className='block mb-2'>
                <label className='block'>
                  {t('vehicle.meeting_point')}*
                </label>
                <AddressInput disabled={!vehicleData.trip1.available} value={vehicleData.trip1}
                  className={formSubmitted && vehicleData.trip1.available && !vehicleData.trip1.street ? '!border-red-500' : ''}
                  onChange={handleChange('trip1')} />
                {/* <input disabled={!vehicleData.trip1.available} type='text' className='border' value={vehicleData.trip1.address_flat} onChange={handleChange('trip1.address_flat')} /> */}
              </div>
              <div className='block mb-2'>
                <label className='block'>
                  {t('vehicle.departure_date_label')}*
                </label>
                <DateInput disabled={!vehicleData.trip1.available} value={vehicleData.trip1.date} onChange={handleChange('trip1.date')}
                  className={formSubmitted && vehicleData.trip1.available && !vehicleData.trip1.date ? '!border-red-500' : ''}
                  minDate={new Date()}
                  maxDate={displayDate(vehicleData.trip2.date)} />
              </div>
              <div className='block mb-2'>
                <label className='block required'>
                  {t('vehicle.seats_number')}*
                </label>
                <select disabled={!vehicleData.trip1.available}
                  className={(formSubmitted && vehicleData.trip1.available) && !vehicleData.trip1.available_seats ? '!border-red-500' : ''}
                  value={vehicleData.trip1.available_seats}
                  onChange={e => handleChange('trip1.available_seats')({ target: { value: parseInt(e.target.value) } })}>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                  <option value={6}>6</option>
                  <option value={7}>7</option>
                </select>
              </div>
            </div>
            <div className='journey-block mb-4'>
              <div className='block mb-2 custom-checkbox'>
                <input type='checkbox' checked={vehicleData.trip2.available} onChange={e => handleChange('trip2.available')({ target: { value: e.target.checked } })}
                  id='checkbox2' />
                <label className='block leading-7' htmlFor='checkbox2'>
                  {t('vehicle.trip2_label')}
                </label>
              </div>
              <div className='block mb-2'>
                <label className='block'>
                  {t('vehicle.meeting_point_back')}*
                </label>
                <AddressInput disabled={!vehicleData.trip2.available} value={vehicleData.trip2}
                  className={formSubmitted && vehicleData.trip2.available && !vehicleData.trip2.street ? '!border-red-500' : ''}
                  onChange={handleChange('trip2')} />
              </div>
              <div className='block mb-2'>
                <label className='block required'>
                  {t('vehicle.return_date_label')}*
                </label>
                <DateInput disabled={!vehicleData.trip2.available} value={vehicleData.trip2.date} onChange={handleChange('trip2.date')}
                  className={formSubmitted && vehicleData.trip2.available && !vehicleData.trip2.date ? '!border-red-500' : ''}
                  minDate={new Date()} />

              </div>
              <div className='block mb-2'>
                <label className='block required'>
                  {t('vehicle.seats_number')}*
                </label>
                <select disabled={!vehicleData.trip2.available}
                  className={(formSubmitted && vehicleData.trip2.available) && !vehicleData.trip2.available_seats ? '!border-red-500' : ''}
                  value={vehicleData.trip2.available_seats}
                  onChange={e => handleChange('trip2.available_seats')({ target: { value: parseInt(e.target.value) } })}>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                  <option value={6}>6</option>
                  <option value={7}>7</option>
                </select>
              </div>
            </div>
            <div className='block mb-8'>
              <label className='block'>
                {t('generic.notes')}
              </label>
              <input type='text' className='border' value={vehicleData.notes} onChange={handleChange('notes')} name='notes' />
            </div>

            <div className='flex flex-row gap-6 mb-8'>
              <button onClick={handleCancel} className='mid flex light'>Annuler</button>
              <button onClick={handleSubmit} className={`mid flex btn-loading ${loading ? 'running' : ''}`}>
                <div className="loading"></div>
                {t('vehicle.confirm_button')}
              </button>
            </div>
            {vehicle && <button className="delete small" onClick={handleDelete}>{t('vehicle.delete_button')}</button>}
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 modal-bg" onClick={onClose}></div>

    </div>
  )
}

export default VehicleModal
